/* global window */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Loading } from 'common/components/layout';
import { getCheckoutHref } from 'common/helpers/routerHelper';
import { createClubSignup } from 'redux/clubSignup/actions';
import { getClub } from 'redux/clubs/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import NotFound from './notFound/NotFound';

const Signup = () => {
  const [isNotFound, setNotFound] = useState(false);
  const params = useParams();
  const dispatch = useDispatch();

  const { slug } = params;
  const club = useSelector((state) => getClubBySlug(state.club, slug));

  useEffect(() => {
    const onError = () => {
      setNotFound(true);
    };
    dispatch(getClub(slug, onError));
  }, [dispatch, slug]);

  useEffect(() => {
    if (club) {
      const onSuccess = () => {
        window.location.href = getCheckoutHref('/club');
      };
      dispatch(createClubSignup(club, onSuccess));
    }
  }, [dispatch, club]);

  if (isNotFound) {
    return <NotFound />;
  }

  return <Loading />;
};

export default Signup;
